import './style.css';

export default function StatsPanel({ stats, element }) {
  // Mostrar datos de albergue/alimentación/acopio/manzana si existe
  if (element) {
    const { type, data } = element;
    const typeLabels = {
      'albergue': 'Albergue',
      'alimentacion': 'Alimentación',
      'acopio': 'Centro de Acopio',
      'manzana': 'Manzana',
      'jam': 'Atasco',
      'focoHistorico': 'Zona afectada por incendio',
    };

    if( type === 'focoHistorico')
      return null;

    return (
      <div className="stats-panel">
        <div className="stats-header">
          <h3>{typeLabels[type] || 'Información'}</h3>
        </div>
        
        <div className="stats-content element-info">
          {type === 'manzana' && (
            <>
              {data.n_per !== undefined && (
                <div className="info-item">
                  <div className="info-label">Población</div>
                  <div className="info-value stat-highlight">{data.n_per?.toLocaleString()} personas</div>
                </div>
              )}
              
              {data.n_vp !== undefined && (
                <div className="info-item">
                  <div className="info-label">Viviendas</div>
                  <div className="info-value stat-highlight">{data.n_vp?.toLocaleString()} viviendas</div>
                </div>
              )}
              
              {data.density !== undefined && (
                <div className="info-item">
                  <div className="info-label">Densidad</div>
                  <div className="info-value stat-highlight">{data.density?.toFixed(1)} hab/ha</div>
                </div>
              )}
              
              {data.comuna !== undefined && (
                <div className="info-item">
                  <div className="info-label">Comuna</div>
                  <div className="info-value stat-highlight">{data.comuna}</div>
                </div>
              )}
            </>
          )}
          {/* {type === 'focoHistorico' && (
            <>
              {data.intensity_tag !== undefined && (
                <div className="info-item">
                  <div className="info-label">Intensidad</div>
                  <div className="info-value stat-highlight">{data.intensity_tag}</div>
                </div>
              )}
            </>
          )} */}
          {type === 'jam' && (
            <>
              {data.street && (
                <div className="info-item">
                  <div className="info-label">Calle</div>
                  <div className="info-value">{data.street}</div>
                </div>
              )}
              
              {data.city && (
                <div className="info-item">
                  <div className="info-label">Ciudad</div>
                  <div className="info-value">{data.city}</div>
                </div>
              )}
              
              {data.speed !== undefined && (
                <div className="info-item">
                  <div className="info-label">Velocidad</div>
                  <div className="info-value stat-highlight">{Number(data.speed).toFixed(1)} km/h</div>
                </div>
              )}
              
              {data.length !== undefined && (
                <div className="info-item">
                  <div className="info-label">Longitud</div>
                  <div className="info-value">{data.length} m</div>
                </div>
              )}
              
              {data.delay !== undefined && (
                <div className="info-item">
                  <div className="info-label">Tiempo de retraso</div>
                  <div className="info-value stat-highlight">{Number(data.delay / 60.0).toFixed(1)} minutos</div>
                </div>
              )}
              
              {data.level !== undefined && (
                <div className="info-item">
                  <div className="info-label">Nivel</div>
                  <div className="info-value">{data.level}</div>
                </div>
              )}
            </>
          )}
          {type !== 'jam' && type !== 'manzana' && (
            <>
              {data.nombre && (
                <div className="info-item">
                  <div className="info-label">Nombre</div>
                  <div className="info-value">{data.nombre}</div>
                </div>
              )}

              {data.recibe && (
                <div className="info-item">
                  <div className="info-label">Recibe</div>
                  <div className="info-value">{data.recibe}</div>
                </div>
              )}

              {data.obs && (
                <div className="info-item">
                  <div className="info-label">Observaciones</div>
                  <div className="info-value">{data.obs}</div>
                </div>
              )}

              {data.horario && (
                <div className="info-item">
                  <div className="info-label">Horario</div>
                  <div className="info-value">{data.horario}</div>
                </div>
              )}
              
              {data.comuna && (
                <div className="info-item">
                  <div className="info-label">Comuna</div>
                  <div className="info-value">{data.comuna}</div>
                </div>
              )}
              
              {data.direccion && (
                <div className="info-item">
                  <div className="info-label">Dirección</div>
                  <div className="info-value">
                    {data.numero ? `${data.direccion} ${data.numero}` : data.direccion}
                  </div>
                </div>
              )}
              
              {data.matriculas && (
                <div className="info-item">
                  <div className="info-label">Matrículas</div>
                  <div className="info-value">
                    {data.matriculas}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  // Mostrar estadísticas de focos
  if (!stats) return null;

  return (
    <div className="stats-panel">
      <div className="stats-header">
        <h3>Estadísticas</h3>
      </div>
      
      <div className="stats-content">
        <div className="stat-item">
          <div className="stat-label">Población en area de influencia del foco</div>
          <div className="stat-value">{stats.population?.toLocaleString() || 0}</div>
          <div className="stat-unit">personas</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Focos cercanos</div>
          <div className="stat-value">{stats.nearbyFocos || 0}</div>
          <div className="stat-unit">en 1 km</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Manzanas cercanas</div>
          <div className="stat-value">{stats.blocksCount || 0}</div>
          <div className="stat-unit">manzanas</div>
        </div>

        <div className="stat-item">
          <div className="stat-label">Área de impacto</div>
          <div className="stat-value">{stats.area?.toFixed(1) || 0}</div>
          <div className="stat-unit">hectáreas</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-label">Densidad promedio</div>
          <div className="stat-value">{stats.avgDensity?.toFixed(0) || 0}</div>
          <div className="stat-unit">hab/km²</div>
        </div>
      </div>
    </div>
  );
}
